import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Loader from "components/Loader/Loader";
import { getSalesUnitFinancials, selectState, setSelectedDates } from "../financials.slice";
import "../../../../Projects/styles/main.scss";
import { selectSalesUnit } from "../../Main/main.slice";
import NoteForSalesUnit from "./NoteForSalesUnit";
import Payables from "./Payables";
import { useAppDispatch } from "hooks/hooks";
import ToolboxButton, { ToolboxButtonIcon } from "Dashboard/components/Buttons/ToolboxButton";
import { hasWriteAccessTo } from "utils/authUtil";
import { HIGH_RISE_SALES_MODULE_NAME } from "Dashboard/scenes/HighRiseSales/domain/HighRiseSalesModule";
import DatePicker from "react-datepicker";
import { FormatDateIso, getLastDateOfMonth } from "utils/dateUtils";

const BottomSectionForSalesUnit = () => {
  const {
    loading,
    financialsSalesUnit,
    selectedDateFrom,
    selectedDateTo } = useSelector(selectState);
  const dispatch = useAppDispatch()

  const salesUnit = useSelector(selectSalesUnit);
  const { salesUnitId } = salesUnit || {};

  const initialDateFrom: Date | null =
    selectedDateFrom ? new Date(selectedDateFrom) : null;
  const initialDateTo: Date | null =
    selectedDateTo ? new Date(selectedDateTo) : null;
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    initialDateFrom, initialDateTo
  ]);

  const selectDate = useCallback((update: [Date | null, Date | null]) => {
    setDateRange(update);
    const [dateFrom, dateTo] = update;
    let lastDayForDateTo = dateTo != null
      ? getLastDateOfMonth(dateTo) : null;
    dispatch(setSelectedDates({
      dateFrom: dateFrom ? FormatDateIso(dateFrom) : undefined,
      dateTo: lastDayForDateTo ? FormatDateIso(lastDayForDateTo) : undefined
    }))
  }, [dispatch]);

  useEffect(() => {
    if (salesUnit) {
      dispatch(getSalesUnitFinancials({
        salesUnitId,
        from: selectedDateFrom,
        to: selectedDateTo
      }));
    }
  }, [dispatch, salesUnitId, selectedDateFrom, selectedDateTo]);

  return (
    <section className="loading-container">
      {loading && <Loader />}
      <h1 className="h1-absolute">
        <ToolboxButton
          icon={ToolboxButtonIcon.Chart}
          tooltip="Info"
        // onClick={hasWriteAccessTo(user, HIGH_RISE_SALES_MODULE_NAME)
        //   ? buttonHandler : undefined}
        />
        {salesUnit?.fullName}
        {/* <StatisticTooltip
          statistics={financials?.general}
          building={building?.building}
          active={statisticActive}
          setActive={setStatisticActive}
        /> */}
      </h1>
      <div className="buildings-bottom-content">
        <Payables
          payables={financialsSalesUnit}
        />
        <NoteForSalesUnit />
        <div className="daily-report-box">
          <div className="monthRange">
            <h3 className="monthRangeTitle"><strong>Prikaz finansija za:</strong></h3>
            <DatePicker
              selectsRange={true}
              startDate={dateRange[0]}
              endDate={dateRange[1]}
              onChange={selectDate}
              dateFormat="MMMM yyyy"
              showMonthYearPicker
              isClearable={true}
              locale="sr-Latn"
            />
          </div>
        </div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </section>
  );
};

export default BottomSectionForSalesUnit;
